// extracted by mini-css-extract-plugin
export default {"container":"ExternalShare_container__A+-DB","share":"ExternalShare_share__RsLIK","text":"ExternalShare_text__rnSQR","img":"ExternalShare_img__qm46T"};